export const tr = {
    'choose-campaign-type': 'Kampanya türünü seçin'
};
